/**
 * Cleans unnecessary double slashes in the path of an absolute URL,
 * without touching protocol, query or fragment.
 *
 * @param rawUrl - The absolute URL to clean.
 */
export const normalizeUrlPathSlashes = (rawUrl: string): string => {
  try {
    const u = new URL(rawUrl);
    u.pathname = u.pathname.replace(/\/{2,}/g, '/');
    return u.toString();
  } catch {
    return rawUrl.replace(/\/{2,}/g, '/');
  }
};
